// ---Third-party imports
import React from 'react'
import {Icon, Label, Menu, Image, Header} from 'semantic-ui-react'
import clsx from 'clsx'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {useGraphics, useSelector, useState, useMemo, useActions} from 'uix/hooks'
import {callIfFunc, size} from 'ldash'
import log from 'uix/logging'
import {AutoPortal} from 'uix/components'
import {Graphics} from 'graphics'

// ---Local imports
import S from './titleGrid.scss'
import {wcUrl, ViewerLink} from './utils'

// ---Globals
let SAMPLE_DATA = [
  {
    title: 'Und Ihr?',
    author: 'Erler, Fritz',
    origin: 'Stuttgart: Eckstein & Stähle, [1917]',
    pageId: 440859,
    pageWidth: 304,
    pageHeight: 419,
    desc: 'test',
    subtitle: 'test',
    released: false,
  },
]

export const TypeIcon = ({datatype, subtype}) => {
  let k = `${datatype}_${subtype}`
  return (
    <Image
      className={S.typeIcon}
      key={k}
      inline
      width="14px"
      src={Graphics.types && Graphics.types[k]}
    />
  )
}

export const StatusLabel = ({i18n, item}) => {
  return item.ot_state !== undefined ? (
    <Label>
      <span className={S.label}>{i18n.get(`ot_state_${item.ot_state}`)}</span>
      <Icon
        name="circle"
        size="small"
        color={item.ot_state > 0 ? 'green' : 'orange'}
        className={S.typeIcon}
      />
    </Label>
  ) : null
}

export const TitleGrid = ({
  data = SAMPLE_DATA,
  grid = true, // use grid layout
  renderFooter = null, // custom footer render func
  linkProps = {},
  align = 'center',
}) => {
  //XXX: probably kill this transformation
  data = useMemo(() => {
    if (size(data) > 0 && data[0].mods) {
      return data.map(row => ({
        ...row,
        title: row.mods.title,
        author: row.mods.author,
        lithographer: row.mods.lithographer,
        subtitle: row.mods.subtitle,
        origin: row.mods.origin,
        pageId: row.op_ot_id,
        pageWidth: row.imgwidth,
        pageHeight: row.imgheight,
      }))
    }
    return data
  })

  let go = useActions(Actions.go)
  const apiurl = useSelector(Sel.apiurl)
  const i18n = useSelector(Sel.i18n)

  let [listView, setSwapView] = useState(true)

  if (grid) {
    listView = false
  }

  let changeDirection = () => setSwapView(!listView)

  let items = data.map((item, i) => {
    let {
      otid,
      title,
      author,
      lithographer,
      origin,
      subtitle,
      pageId,
      pageWidth,
      pageHeight,
      crop,
      released,
    } = item

    let maxPageHeight = 150
    let maxPageWidth = 150

    if (pageHeight > maxPageHeight) {
      pageWidth = Math.round((pageWidth * maxPageHeight) / pageHeight)
      pageHeight = maxPageHeight
    }

    if (pageWidth > pageHeight) {
      pageHeight = Math.round((pageHeight * maxPageWidth) / pageWidth)
      pageWidth = maxPageWidth
    }

    const pageImg = {
      width: pageWidth,
      height: pageHeight,
      backgroundPosition: 'center',
      minWidth: pageWidth,
      minHeight: pageHeight,
      transform: listView ? 'scale(0.75)' : 'scale(1)',
    }
    linkProps = {...linkProps, id: otid}

    let creator = !author ? lithographer : author

    const footer = callIfFunc(renderFooter, item)

    // if no pageId available show placeholder
    let imageSrc = pageId
      ? wcUrl(apiurl, 304, pageId)
      : apiurl.href('/static/graphics/error/noImageSuppliedThumbTransparent.svg')

    return (
      <div className={S.card} key={i}>
        <div className={S.titleInfo}>
          <div className={S.showcase} key={i}>
            <ViewerLink {...linkProps}>
              {!listView && (
                <div className={S.infoArea}>
                  {' '}
                  <StatusLabel i18n={i18n} item={item} />
                </div>
              )}
              <img style={pageImg} loading="lazy" src={imageSrc} />
            </ViewerLink>
          </div>
          <div className={S.content}>
            <div className={S.topContainer}>
              {creator ? (
                <a className={S.creator}>{creator}</a>
              ) : (
                <h2 className={S.title}>
                  <ViewerLink {...linkProps}>{title}</ViewerLink>
                </h2>
              )}
              {listView && (
                <div className={clsx(S.infoArea, S.list)}>
                  {' '}
                  <StatusLabel i18n={i18n} item={item} />
                </div>
              )}
            </div>
            <div className={S.textArea}>
              <ViewerLink {...linkProps}>
                {creator && <h2 className={S.title}>{title}</h2>}
                <div className={S.subtitle}>{subtitle}</div>
              </ViewerLink>
            </div>
            <div className={S.bottomContainer}>
              <a className={S.origin}>{origin}</a>
              {listView ? <TypeIcon datatype={item.datatype} subtype={item.subtype} /> : null}
            </div>
          </div>
        </div>
        {footer && <a className={S.footer}>{footer}</a>}
      </div>
    )
  })

  return (
    <>
      {grid === undefined && (
        <AutoPortal target="TabMenuPortal">
          <Menu>
            <Menu.Item
              icon={listView === true ? 'grid layout' : 'th list'}
              title="Grid Layout"
              onClick={changeDirection}
            />
          </Menu>
        </AutoPortal>
      )}
      <div
        className={clsx(
          S.flexContainer,
          listView && clsx(S.list, align === 'left' ? S.left : S.center)
        )}
      >
        {items}
      </div>
    </>
  )
}
